(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["goals-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    const CAROUSEL_BREAKPOINT = 749;
    const TABLET_MIN = 750;
    const TABLET_MAX = 1240;

    function isCarouselViewport() {
      return window.innerWidth <= CAROUSEL_BREAKPOINT;
    }

    function isTabletViewport() {
      return window.innerWidth >= TABLET_MIN && window.innerWidth <= TABLET_MAX;
    }

    function initGoalCardTap(carousel) {
      const cards = carousel.querySelectorAll('.goal-card');

      carousel.addEventListener('click', function (e) {
        if (!isTabletViewport()) return;

        if (e.target.closest('.goal-card__shop-btn')) return;

        const card = e.target.closest('.goal-card');
        if (!card || !carousel.contains(card) || !card.querySelector('.goal-card__hover')) {
          cards.forEach(function (c) {
            c.classList.remove('goal-card--active');
          });
          return;
        }

        const wasActive = card.classList.contains('goal-card--active');
        cards.forEach(function (c) {
          c.classList.remove('goal-card--active');
        });
        if (!wasActive) {
          card.classList.add('goal-card--active');
        }
      });
    }

    function initCarousel(carousel) {
      const track = carousel.querySelector('.goals-carousel__track');
      const prev = carousel.querySelector('.goals-carousel__btn--prev');
      const next = carousel.querySelector('.goals-carousel__btn--next');
      const controls = carousel.querySelector('.goals-carousel__controls');

      if (!track || !prev || !next) return;

      function getCards() {
        return Array.from(track.querySelectorAll('.group-block, .goal-card'));
      }

      function getActiveIndex() {
        const cards = getCards();
        if (!cards.length) return 0;
        const width = cards[0].offsetWidth + parseFloat(getComputedStyle(track).gap || '0');
        return Math.round(track.scrollLeft / Math.max(width, 1));
      }

      function scrollToIndex(index) {
        const cards = getCards();
        const clampedIndex = Math.max(0, Math.min(index, cards.length - 1));
        const card = cards[clampedIndex];
        if (!card) return;
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      function updateButtons() {
        const carouselActive = isCarouselViewport();
        if (controls) {
          controls.setAttribute('aria-hidden', carouselActive ? 'false' : 'true');
        }
        if (!carouselActive) return;
        const cards = getCards();
        const index = getActiveIndex();
        prev.disabled = index <= 0;
        next.disabled = index >= cards.length - 1;
      }

      prev.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() - 1);
      });

      next.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() + 1);
      });

      track.addEventListener('scroll', updateButtons, { passive: true });

      // Re-evaluate on resize (desktop<->mobile transitions)
      window.addEventListener('resize', updateButtons, { passive: true });

      window.addEventListener('resize', function () {
        if (!isTabletViewport()) {
          carousel.querySelectorAll('.goal-card').forEach(function (c) {
            c.classList.remove('goal-card--active');
          });
        }
      }, { passive: true });

      updateButtons();
    }

    document.querySelectorAll('.goals-carousel').forEach(function (carousel) {
      initCarousel(carousel);
      initGoalCardTap(carousel);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trusted-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(carousel) {
      const track = carousel.querySelector('.trusted-carousel__track');
      const prev = carousel.querySelector('.trusted-carousel__btn--prev');
      const next = carousel.querySelector('.trusted-carousel__btn--next');

      if (!track || !prev || !next) return;

      function getScrollAmount() {
        const card = track.querySelector('.group-block');
        if (!card) return 120;
        const gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 8;
        return card.offsetWidth + gap;
      }

      function updateButtons() {
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      updateButtons();
    }

    document.querySelectorAll('.trusted-carousel').forEach(initCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
